/* eslint-disable camelcase */
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Order } from 'shell/view-models/order';
import { AxiosResponse } from 'axios';
import { HttpResponseListPayloadQuarkus } from 'shell/models/http-response';
import {
  FiltersNotificationManagementVM,
  NotificationManagementVM,
} from 'practice/view-models/notification-management';
import { PDNDNotification } from 'shell/models/pdnd-notification';
import { DateTime } from 'luxon';
import { parseProgressivoPratice } from 'practice/utils/practice-research-transform';
import { Operation } from 'shell/view-models/operation';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';

export const transformDataset = (values: Partial<FiltersNotificationManagementVM>): string => {
  const { orders, page, rowsPerPage } = values;

  const transformedFilters: OperationObject = {
    tipoRegistro: {
      value: values.typeRegister?.toString() || '',
      operation: Operation.EQUALS,
    },
    idAnnoPratica: {
      value: values.year || '',
      operation: Operation.EQUALS,
    },
    progressivoPratica_da: {
      value: values.fromNumber || '',
      operation: Operation.EQUALS,
    },
    progressivoPratica_a: {
      value: values.toNumber || '',
      operation: Operation.EQUALS,
    },
    stato: {
      value: values.state || '',
      operation: Operation.EQUALS,
    },
    tipoComunicazione: {
      value: values.communicationType || '',
      operation: Operation.EQUALS,
    },
    tipoTrasmissione: {
      value: values.transmissionType || '',
      operation: Operation.EQUALS,
    },
    dataTrasmissione_da: {
      value: values.transmissionDateFrom?.toFormat('yyyy-MM-dd') || '',
      operation: Operation.EQUALS,
    },
    dataTrasmissione_a: {
      value: values.transmissionDateTo?.toFormat('yyyy-MM-dd') || '',
      operation: Operation.EQUALS,
    },
    dataStato_da: {
      value: values.stateDateFrom?.toFormat('yyyy-MM-dd') || '',
      operation: Operation.EQUALS,
    },
    dataStato_a: {
      value: values.stateDateTo?.toFormat('yyyy-MM-dd') || '',
      operation: Operation.EQUALS,
    },
  };

  const ordersToTransform = orders || {};

  const ordersMapped: Order = {
    description: ordersToTransform.batchDescription,
    name: ordersToTransform.id,
    enabled: ordersToTransform.active,
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
    page,
    rowsPerPage,
  })}`;
};

type JSONNotifica = {
  idempotenceToken: string;
  paProtocolNumber: string;
  subject: string;
  recipients: [
    {
      recipientType: string;
      taxId: string; // Codice fiscale
      denomination: string; // Cognome e nome
    }
  ];
};

export const transformerResponse = (
  response: AxiosResponse<HttpResponseListPayloadQuarkus<PDNDNotification>>
): Array<NotificationManagementVM> => {
  return response.data.payload.map((item) => {
    const progressivoPratica = parseProgressivoPratice(item.progressivoPratica);
    const json: JSONNotifica = JSON.parse(item.jsonNotifica || '{}');
    const codiceFiscale = (json.recipients || [])[0]?.taxId || '';

    const itemResult: NotificationManagementVM = {
      id: item.idNotifica,
      practiceId: `${item.tipoRegistro}.${item.idAnnoPratica}.${progressivoPratica}`,
      communicationId: item.iun?.toString(),
      communicationType: item.codiceAmbito,
      cf: codiceFiscale || '',
      transmissionType: item.tipoTrasmissione,
      trasmissionDate: item.timestampInserimento
        ? DateTime.fromISO(item.timestampInserimento).toFormat('dd/MM/yyyy')
        : '',
      state: item.descrizioneStato,
      codeState: item.stato,
      stateDate: item.timestampUltimoAggiornamento
        ? DateTime.fromISO(item.timestampUltimoAggiornamento).toFormat('dd/MM/yyyy')
        : '',
    };
    return itemResult;
  });
};
